import React, { useState } from "react";
import { googleReviews, stats, siteConfig } from "../data/mockData";
import { Star, ExternalLink } from "lucide-react";
import ReviewCard from "./reviews/ReviewCard";

const GoogleReviews = () => {
  const [visibleCount, setVisibleCount] = useState(6);
  const STAR_SIZE = 22;
  const STAR_COUNT = 5;
  const REVIEWS_PER_PAGE = 6;

  const showMore = () => {
    setVisibleCount((prev) => Math.min(prev + REVIEWS_PER_PAGE, googleReviews.length));
  };

  return (
    <section className="py-20 lg:py-28 bg-[#F9F7F4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            {/* Google G logo */}
            <svg width="24" height="24" viewBox="0 0 24 24" className="flex-shrink-0">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span className="text-sm font-semibold text-[#5A6B5A] uppercase tracking-wider">
              Google Reviews
            </span>
          </div>
          <h2
            className="text-3xl sm:text-4xl font-bold text-[#1B2A1B] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center gap-3">
            <div className="flex">
              {[...Array(STAR_COUNT)].map((_, i) => (
                <Star key={`gr-star-${i}`} size={STAR_SIZE} className="text-yellow-500 fill-yellow-500" />
              ))}
            </div>
            <span className="text-2xl font-bold text-[#1B2A1B]">{stats.reviewScore}</span>
            <span className="text-[#5A6B5A]">based on {stats.totalReviews} reviews</span>
          </div>
          <a
            href={siteConfig.reviewUrl}
            
            
            className="inline-flex items-center gap-1 text-sm text-[#3A7D44] font-medium mt-3 hover:underline"
          >
            See all reviews on Google <ExternalLink size={12} />
          </a>
        </div>

        {/* Reviews Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {googleReviews.slice(0, visibleCount).map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

        {/* Show More */}
        {visibleCount < googleReviews.length && (
          <div className="text-center mt-10">
            <button
              onClick={showMore}
              className="px-6 py-3 text-sm font-semibold text-[#3A7D44] border border-[#3A7D44] rounded-lg hover:bg-[#F1F8F2] transition-colors"
            >
              Show More Reviews
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default GoogleReviews;
